/**
 *
 * @export
 * @class File
 */
  

export class File {
    //Fields
    name: string;
    path:string;
    size:number;
    type:number;
    dateTime:string;
    permissions:string;
  
    constructor(
        name: string,
        path:string,
        size:number,
        type:number,
        dateTime:string,
        permissions:string,
    ) {
      this.name=name;
      this.path=path;
      this.size= size;
      this.type=type;
      this.dateTime=dateTime;
      this.permissions=permissions;
    } 
    
   /**
    * name
    */
     
}
  